/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /*
   * 2026-10-13 - Add-on-only products (product type containing "Choker",
   * "Candle" or "Chain", as in 6.1) are not sold on their own. When every
   * cart line is one of them, disable checkout, hide the express checkout
   * buttons and show a warning.
   *
   * The type check lives in snippets/larimar-add-on-only.liquid; it flags
   * each cart item (data-larimar-add-on-only, cart-line-items.liquid) and
   * hides "Buy it now" on those products (product-buttons.liquid). This is a
   * deterrent: a direct checkout link can still bypass it.
   *
   * Timing: Broadcast 8.1.1 replaces the cart items, fires
   * "theme:cart:change" and then re-enables every cart button
   * (enableCartButtons), all in one synchronous step. The check is queued as
   * a microtask so it runs right after that step, before the next paint.
   */
  const ADD_ON_ONLY_ATTRIBUTE = "data-larimar-add-on-only";
  const CHECKOUT_WARNING_CLASS = "larimar-checkout-warning";
  const CHECKOUT_WARNING_TEXT =
    "These products are not sold separately and are only available for purchase when ordering any of our larimar or amber jewelry.";

  function isCartAddOnOnly() {
    const items = [...document.querySelectorAll("[data-items-holder] [data-item]")];

    // An empty cart has nothing to block.
    return items.length > 0 && items.every((item) => item.hasAttribute(ADD_ON_ONLY_ATTRIBUTE));
  }

  function setCheckoutBlocked(blocked) {
    // Cart page and cart drawer can each have a checkout button.
    document.querySelectorAll("[name='checkout']").forEach((checkoutBtn) => {
      checkoutBtn.disabled = blocked;
      checkoutBtn.style.opacity = blocked ? "0.5" : "";
      checkoutBtn.style.cursor = blocked ? "not-allowed" : "";

      const previous = checkoutBtn.previousElementSibling;
      const warning = previous?.classList.contains(CHECKOUT_WARNING_CLASS) ? previous : null;

      if (blocked && !warning) {
        const msg = document.createElement("p");
        msg.className = `${CHECKOUT_WARNING_CLASS} text-warning`;
        msg.textContent = CHECKOUT_WARNING_TEXT;
        checkoutBtn.parentNode.insertBefore(msg, checkoutBtn);
      } else if (!blocked && warning) {
        warning.remove();
      }
    });

    // Express checkout (Shop Pay, PayPal, Google Pay...) would skip the disabled button.
    document.querySelectorAll(".additional-checkout-buttons").forEach((buttons) => {
      buttons.style.display = blocked ? "none" : "";
    });
  }

  function updateCheckoutButton() {
    setCheckoutBlocked(isCartAddOnOnly());
  }

  // Covers quantity changes and removals on the cart page and in the drawer.
  document.addEventListener("theme:cart:change", () => {
    queueMicrotask(updateCheckoutButton);
  });

  updateCheckoutButton();

  /* Position product prices and sale badges. */
  function moveProductPriceIntoHeading() {
    document.querySelectorAll(".product__page").forEach((page) => {
      const heading = page.querySelector(".product__head");
      const price = page.querySelector('[id^="Price-"]');
      const badges = page.querySelector(".product__badges");

      if (!heading || !price || !badges) return;
      if (price.dataset.larimarPositioned) return;

      price.dataset.larimarPositioned = "true";

      // Move only the price, leaving shipping and payment terms outside it.
      heading.append(price);

      // Move Shop Pay installments below the purchase buttons.
      // Keep the installment form outside the main product form.
      // The accelerated checkout slot (below) re-asserts itself directly after
      // product-form, so the final order is: form > slot > installments.
      const paymentTerms = page.querySelector(".shop-pay-terms");
      const productForm = page.querySelector("product-form");

      if (paymentTerms && productForm) {
        productForm.after(paymentTerms);
      }

      let movedSale = null;

      function moveSaleBadges() {
        // Remove the previous variant's badges, if still present.
        movedSale?.remove();

        // Move the current discount and final-sale badges above the title.
        movedSale = price.querySelector(".product__sale");

        if (movedSale) {
          badges.append(movedSale);
        }
      }

      moveSaleBadges();

      // The theme replaces the price's contents when the variant changes.
      // Observe direct children only; moving nested badges won't retrigger it.
      const observer = new MutationObserver(moveSaleBadges);
      observer.observe(price, { childList: true });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      moveProductPriceIntoHeading,
      { once: true }
    );
  } else {
    moveProductPriceIntoHeading();
  }

  document.addEventListener(
    "theme:product-info:loaded",
    moveProductPriceIntoHeading
  );

  /*
   * 2026-11-03 - Move the Shop Promise delivery slot out of
   * <shopify-accelerated-checkout> to directly after <product-form>.
   *
   * Matched by its data-shopify attribute, not by position: before Shopify
   * hydrates the buttons, div:nth-child(2) is a loading skeleton that gets
   * replaced, which made the move fail on some page loads.
   * One body-level observer re-runs the check at most once per frame. If
   * Shopify renders a new slot, it replaces the previously moved one.
   * Only the delivery slot moves; the wallet buttons stay inside the form.
   */
  const ACCEL_SLOT_SELECTOR = '.shopify-payment-button [data-shopify="shop-promise-payment-button-slot"]';
  const ACCEL_TARGET_SELECTOR = ".product__block > product-form";
  const ACCEL_MOVED_ATTRIBUTE = "data-larimar-accel-moved";

  function moveAcceleratedSlot() {
    document.querySelectorAll(".product__page").forEach((page) => {
      const target = page.querySelector(ACCEL_TARGET_SELECTOR);
      if (!target) return;

      // Once moved, the slot is outside .shopify-payment-button and no longer matches.
      const slot = page.querySelector(ACCEL_SLOT_SELECTOR);

      if (slot) {
        page.querySelectorAll(`[${ACCEL_MOVED_ATTRIBUTE}]`).forEach((node) => node.remove());
        slot.setAttribute(ACCEL_MOVED_ATTRIBUTE, "");
      }

      // Keep the slot directly after the form, even if something else
      // (e.g. .shop-pay-terms above) was inserted there later.
      const moved = page.querySelector(`[${ACCEL_MOVED_ATTRIBUTE}]`);

      if (moved && target.nextElementSibling !== moved) {
        target.after(moved);
      }
    });
  }

  let accelFrame = 0;

  function scheduleAcceleratedSlot() {
    if (accelFrame) return;

    accelFrame = requestAnimationFrame(() => {
      accelFrame = 0;
      moveAcceleratedSlot();
    });
  }

  function initAcceleratedSlot() {
    moveAcceleratedSlot();

    // Body, not the section: survives section re-renders and quick view.
    new MutationObserver(scheduleAcceleratedSlot).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAcceleratedSlot, { once: true });
  } else {
    initAcceleratedSlot();
  }

  /* Klaviyo favorites button next to Add to cart. */
  const STYLE_ID = "larimar-favorites-inline-style";

  function injectFavoritesStyle(){
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
      .product__submit__buttons.larimar-has-favorites{grid-template-columns:minmax(0,1fr) 51px}
      .larimar-favorites-inline{display:flex;margin:0 !important;padding:0 !important;border:1px solid currentColor;align-self:start;aspect-ratio:1}
      .larimar-favorites-inline klaviyo-favorites-button,
      .larimar-favorites-inline klaviyo-favorites-button *:has(.kl-hub-favorites-widget){display:flex !important;flex:1 1 auto;width:100% !important;height:100% !important;margin:0 !important;padding:0 !important}
      .larimar-favorites-inline .kl-hub-favorites-widget{flex:1 1 auto;width:100% !important;height:100% !important;min-width:0 !important;min-height:0 !important;margin:0 !important;border-radius:0 !important;justify-content:center}
      @media only screen and (max-width:479px){
        .product__submit__buttons--inline.larimar-has-favorites > .product__submit__item:first-child{grid-column:1 / -1}
      }
      @media only screen and (min-width:480px){
        .product__submit__buttons--inline.larimar-has-favorites{grid-template-columns:repeat(2,minmax(0,1fr)) 51px}
      }
    `;
    document.head.append(style);
  }

  // El bloque queda dentro del <form> de producto: evita que un <button> sin type agregue al carrito
  function preventFormSubmit(block){
    const fix = () => block.querySelectorAll("button:not([type])").forEach(btn => btn.type = "button");
    fix();
    new MutationObserver(fix).observe(block, {childList: true, subtree: true});
  }

  function moveFavoritesNextToAddToCart(){
    document.querySelectorAll(".product__page").forEach(page => {
      const favorites = page.querySelector("klaviyo-favorites-button")?.closest(".shopify-app-block");
      const buttons = page.querySelector(".product__submit__buttons");
      if (!favorites || !buttons || favorites.dataset.larimarPositioned) return;
      favorites.dataset.larimarPositioned = "true";
      injectFavoritesStyle();
      buttons.classList.add("larimar-has-favorites");
      favorites.classList.add("larimar-favorites-inline");
      buttons.append(favorites);
      preventFormSubmit(favorites);
    });
  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", moveFavoritesNextToAddToCart, {once: true})
    : moveFavoritesNextToAddToCart();
  document.addEventListener("theme:product-info:loaded", moveFavoritesNextToAddToCart);

})();